import React from 'react'
import { motion } from 'framer-motion'

const BGMotion = () => {
    return (
        <div className="absolute inset-0 overflow-hidden -z-10">
            {/* Animated gradient background */}
            <motion.div
                className="absolute inset-0 bg-gradient-to-br from-teal-25 via-emerald-100 to-emerald-50"
                animate={{
                    backgroundPosition: ["0% 0%", "100% 100%"],
                }}
                transition={{
                    duration: 15,
                    repeat: Infinity,
                    repeatType: "reverse",
                    ease: "linear",
                }}
            />

            {/* Floating bubbles */}
            {[...Array(12)].map((_, i) => (
                <motion.div
                    key={i}
                    className="absolute rounded-full bg-emerald-200"
                    style={{
                        width: `${Math.random() * 100 + 50}px`,
                        height: `${Math.random() * 100 + 50}px`,
                        left: `${Math.random() * 100}%`,
                        top: `${Math.random() * 100}%`,
                    }}
                    animate={{
                        y: [0, (Math.random() - 0.5) * 200],
                        x: [0, (Math.random() - 0.5) * 200],
                        rotate: [0, 360],
                        opacity: [0.2, 0.4, 0.2],
                    }}
                    transition={{
                        duration: Math.random() * 20 + 10,
                        repeat: Infinity,
                        repeatType: "reverse",
                        ease: "easeInOut",
                    }}
                />
            ))}

            {/* Pulse rings */}
            {[...Array(5)].map((_, i) => (
                <motion.div
                    key={i}
                    className="absolute border-2 border-emerald-300/50 rounded-full"
                    style={{
                        width: `${i * 200 + 100}px`,
                        height: `${i * 200 + 100}px`,
                        left: "50%",
                        top: "50%",
                        translateX: "-50%",
                        translateY: "-50%",
                    }}
                    animate={{
                        scale: [1, 1.5],
                        opacity: [0.5, 0],
                    }}
                    transition={{
                        duration: 8 + i * 2,
                        repeat: Infinity,
                        ease: "easeOut",
                    }}
                />
            ))}

            {/* Animated grid pattern */}
            <motion.div
                className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgdmlld0JveD0iMCAwIDYwIDYwIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9InJnYmEoMjAsIDE4NCwgMTYxLCAwLjAzKSIgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMzYgMzRINmMtMS4xIDAtMi0uOS0yLTJWNmMwLTEuMS45LTIgMi0yaDI4YzEuMSAwIDIgLjkgMiAydjI4YzAgMS4xLS45IDItMiAyem0yNCAyNEg2Yy0xLjEgMC0yLS45LTItMlY2YzAtMS4xLjktMiAyLTJoMjhjMS4xIDAgMiAuOSAyIDJ2MjhjMCAxLjEtLjkgMi0yIDJ6TTM2IDYwSDZjLTEuMSAwLTItLjktMi0yVjMwYzAtMS4xLjktMiAyLTJoMjhjMS4xIDAgMiAuOSAyIDJ2MjhjMCAxLjEtLjkgMi0yIDJ6TTYwIDM0SDMwYy0xLjEgMC0yLS45LTItMlY2YzAtMS4xLjktMiAyLTJoMzBjMS4xIDAgMiAuOSAyIDJ2MjZjMCAxLjEtLjkgMi0yIDJ6TTYwIDYwSDMwYy0xLjEgMC0yLS45LTItMlYzMGMwLTEuMS45LTIgMi0yaDMwYzEuMSAwIDIgLjkgMiAydjI4YzAgMS4xLS45IDItMiAyek02IDYwYy0xLjEgMC0yLS45LTItMlYzMGMwLTEuMS45LTIgMi0yaDI0YzEuMSAwIDIgLjkgMiAydjI4YzAgMS4xLS45IDItMiAySDZ6Ii8+PC9nPjwvZz48L3N2Zz4=')]"
                animate={{
                    opacity: [0.3, 0.5, 0.3],
                }}
                transition={{
                    duration: 15,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            />
        </div>
    )
}

export default BGMotion
